const MODE_POPUP = 'popup';
const MODE_PAGE = 'page';


const popupPageModeMixin = {
  props: {
    mode: {
      type: String,
      default: MODE_POPUP,
    },
  },
  computed: {
    isPage() {
      return this.mode === MODE_PAGE;
    },
    isPopup() {
      return this.mode === MODE_POPUP;
    },
  },
};


export default popupPageModeMixin;



// WEBPACK FOOTER //
// ./src/mixins/popupPageModeMixin.js